import angular from 'angular';
import subItemsTemplate from './subItems.template.html';

/*******************************************************************************
 * Component: subItemsContent
 *
 * This is the component to be used to manage the list of subItems for a kit
 * in the AddChangeItemDialog. This will utilize the addChangeItemDialog's
 * component controller for shared data management.
 *******************************************************************************/
export const subItemsContentComponent = {
  require: { dialogCtrl: '^^addChangeItemDialogContent' },
  template: subItemsTemplate,
  controller: 'SubItemsController',
  controllerAs: '$siCtrl'
};

/* @ngInject */ export function SubItemsController(
  $scope,
  CommonUIGridTemplates,
  Tools,
  uiGridConstants
) {
  /*****************************************************************************
   * Properties
   *****************************************************************************/
  /** Controller Instance. */ var mThis = this;
  /** Subitem normal total price value. */ mThis.groupValue = 0;
  /** Selected Item to add. */ mThis.selectedItemToAdd = null;
  /** Validators Object. */ mThis.validators = {};

  /*-----------------------------------------------*/
  /* Grid to display items that are part of a kit. */
  /*-----------------------------------------------*/
  mThis.dgSubItems = {
    enableColumnMenus: false,
    enableCellEdit: false,
    enableCellEditOnFocus: true,
    enableHorizontalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
    enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
    minRowsToShow: 4,
    maxRowsToShow: 4,
    data: [],
    onRegisterApi: function (gridApi) {
      mThis.dgSubItems.api = gridApi;

      /***************************************************************************
       * afterCellEdit */
      /**
       * This event is raised after a cell has been edited. When an item has been
       * added to the list of sub items, recalculate group totals.
       ***************************************************************************/
      gridApi.edit.on.afterCellEdit($scope, function (rowEntity, colDef) {
        setGroupTotals();
      });
    },
    columnDefs: [
      {
        name: 'item',
        field: 'name',
        cellClass: getInactiveCellClass
      },
      {
        name: 'price',
        field: 'amount',
        cellFilter: 'currency',
        enableCellEdit: true,
        editableCellTemplate: CommonUIGridTemplates.CELL_NUMBER_INPUT,
        precision: 2,
        allowNegative: false,
        blankIsNan: false,
        maxWidth: 125,
        cellClass: getInactiveCellClass
      },
      {
        field: 'delete',
        width: 30,
        cellTemplate: CommonUIGridTemplates.CELL_DELETE_ROW,
        displayName: ' ',
        enableSorting: false,
        cellClass: getInactiveCellClass,
        appScope: $scope
      }
    ]
  };

  /*****************************************************************************
   * Dataproviders
   *****************************************************************************/
  /** List of ItemListItems to select sub items from */ mThis.availableSubItems;

  /***************************************************************************
   * checkSubItems */
  /**
   * Used to check that at least one sub item has been added.
   *
   * @return  String  Null=Valid, Otherwise invalid
   ***************************************************************************/
  mThis.checkSubItems = function () {
    if ((mThis.item.subItems || []).length == 0)
      return 'Kits require at least one sub item';

    return null;
  };

  /***************************************************************************
   * disableSubItemsLoad */
  /**
   * Used to disable the load button. Returns true when a valid selection has been made.
   *
   * @return  Boolean  Indication to disable/enable button
   ***************************************************************************/
  mThis.disableSubItemsLoad = function () {
    return (
      !mThis.selectedItemToAdd || typeof mThis.selectedItemToAdd != 'object'
    );
  };

  /*****************************************************************************
   * getInactiveCellClass */
  /**
   * Returns the CSS class name to be applied to the grid cell on inactive
   * items.
   *
   * @param  grid   ui-grid reference
   * @param  row    ui-grid row
   * @param  col    ui-grid column
   *
   * @return  String   CSS class name inactive or empty string.
   *****************************************************************************/
  function getInactiveCellClass(grid, row, col) {
    return !row.entity.active ? 'inactive' : '';
  }

  /***************************************************************************
   * handleSubItems */
  /**
   * Add subitem button handler. Adds the selected product to the group as a
   * <b>ProductListItem</b>.
   ***************************************************************************/
  mThis.handleSubItems = function () {
    /*-----------------------------------*/
    /* Ensure an item has been selected. */
    /*-----------------------------------*/
    if (mThis.disableSubItemsLoad()) return;

    /*--------------------------------------------*/
    /* Create a ProductListItem from the selected */
    /* item and add to the list of subItems       */
    /*--------------------------------------------*/
    var pli = angular.copy(mThis.selectedItemToAdd);
    ((pli.name = mThis.selectedItemToAdd.shortDescription),
      /*-------------*/
      /* Update grid */
      /*-------------*/
      mThis.dgSubItems.data.push(pli));
    setGroupTotals();

    /*----------------------------------------*/
    /* Update the list of available subitems. */
    /*----------------------------------------*/
    refreshAvailableSubItems();

    /*-------------------------*/
    /* Clear the selected item */
    /*-------------------------*/
    mThis.selectedItemToAdd = null;

    /*-------------------------------------------*/
    /* Return focus to the add item input field. */
    /*-------------------------------------------*/
    $('lazy-typeahead > input').focus();
  };

  /***************************************************************************
   * onInit */
  /**
   * Component initialization callback function. Set the validators object
   * reference on the tab object.
   ***************************************************************************/
  mThis.$onInit = function () {
    mThis.dialogCtrl.tabSubItems.validators = mThis.validators;

    /*-------------------------------------------------------------------*/
    /* Set up the onSelect tab handler to refresh the grid. A bug in     */
    /* ui-grid causes column headers to disappear when the viewport size */
    /* changes or when a grid hidden in the DOM is eventually shown.     */
    /*-------------------------------------------------------------------*/
    mThis.dialogCtrl.tabSubItems.onSelect = function () {
      mThis.dgSubItems.api.core.refresh();
    };

    /*------------------------------------------*/
    /* Set initialized to true so grid can load */
    /*------------------------------------------*/
    mThis.initialized = true;
  };

  /***************************************************************************
   * onSubItemLoad */
  /**
   * Blur handler for the add item input in the sub items tab. When the field
   * blurs, focus is put on add button if it's not disabled.
   ***************************************************************************/
  mThis.onSubItemLoad = function () {
    if (!mThis.disableSubItemsLoad())
      $("button[ng-click|='$siCtrl.handleSubItems()']").focus();
  };

  /***************************************************************************
   * refreshAvailableSubItems */
  /**
   * Update the list of available subitems the user can add to the current group
   * item to exclude those already added.
   ***************************************************************************/
  function refreshAvailableSubItems() {
    mThis.availableSubItems = (mThis.dialogCtrl.itemList || []).filter(
      function (ili) {
        if (!ili.active) return;

        return (
          mThis.dialogCtrl.uiFlags.isGroup &&
          mThis.dialogCtrl.isSubItemType(ili.type) &&
          !(mThis.item.subItems || []).some(function (si) {
            return si.id == ili.id;
          })
        );
      }
    );
  }

  /***************************************************************************
   * removeSubItem */
  /**
   * Remove item from the sub items grid.
   *
   * @param   subItem  Sub item to remove.
   ***************************************************************************/
  function removeSubItem(subItem) {
    /*---------------------------*/
    /* Nothing to remove, abort. */
    /*---------------------------*/
    if (!subItem) return;

    /*--------------------------------------------------*/
    /* Remove sub item from the grid and update totals. */
    /*--------------------------------------------------*/
    var index = mThis.dgSubItems.data.indexOf(subItem);
    mThis.dgSubItems.data.splice(index, 1);

    /*----------------------------------------*/
    /* Update the list of available subitems. */
    /*----------------------------------------*/
    refreshAvailableSubItems();

    /*------------------------*/
    /* Clear the input field. */
    /*------------------------*/
    $('lazy-typeahead > input').val('');
    $('lazy-typeahead > input').blur();
    mThis.selectedItemToAdd = null;

    setGroupTotals();
  }

  /***************************************************************************
   * setGroupTotals */
  /**
   * Calculates the group amount from the chosen amounts of the sub items and
   * gets the total value of the group from the original items.
   ***************************************************************************/
  function setGroupTotals() {
    mThis.item.amount = mThis.groupValue = 0;

    /*--------------------------------------------------------------*/
    /* Build a list of the sub item IDs to check the main list of   */
    /* items to use when determining the actual value of the group. */
    /*--------------------------------------------------------------*/
    var subIDs = [];

    /*------------------------*/
    /* Update the group price */
    /*------------------------*/
    angular.forEach(mThis.item.subItems, function (si) {
      subIDs.push(si.id);
      mThis.item.amount = Tools.roundToPrecision(
        mThis.item.amount + (Number(si.amount) || 0),
        2
      );
    });

    /*------------------------*/
    /* Update the group value */
    /*------------------------*/
    angular.forEach(mThis.dialogCtrl.itemList, function (ili) {
      if (subIDs.indexOf(ili.id) > -1)
        mThis.groupValue = Tools.roundToPrecision(
          mThis.groupValue + (Number(ili.amount) || 0),
          2
        );
    });
  }

  /*---------------------------------------------------*/
  /* Set up an accessor the item property from the     */
  /* dialogCtrl. Use an empty object for data binding. */
  /*---------------------------------------------------*/
  Object.defineProperty(mThis, 'item', {
    get: function () {
      return mThis.dialogCtrl ? mThis.dialogCtrl.item : {};
    }
  });

  /*--------------------------------------------*/
  /* Set up listener for the row delete event   */
  /*--------------------------------------------*/
  $scope.$on(
    CommonUIGridTemplates.EVENT_DELETE_ROW,
    function (event, grid, row) {
      removeSubItem(row.entity);
    }
  );

  /*------------------------------------------*/
  /* Watch for when the item reference        */
  /* changes so the UI sources can be updated */
  /*------------------------------------------*/
  $scope.$watch(
    function () {
      return mThis.item;
    },
    function (item) {
      if (!item) return;

      /*----------------------------------------*/
      /* Update the list of available subitems. */
      /*----------------------------------------*/
      refreshAvailableSubItems();

      /*------------------------*/
      /* Update the grid object */
      /*------------------------*/
      mThis.dgSubItems.data = item.subItems;

      /*-------------------*/
      /* Update the totals */
      /*-------------------*/
      setGroupTotals();
    }
  );
}
